function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { isLeaf } from "../../../models/gridColumnGrouping.js";
import { isDeepEqual } from "../../../utils/utils.js";
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
var recurrentUnwrapGroupingColumnModel = function(columnGroupNode, parents, unwrappedGroupingModelToComplete) {
    if (isLeaf(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) {
            throw new Error([
                "MUI X: columnGroupingModel contains duplicated field",
                "column field ".concat(columnGroupNode.field, " occurs two times in the grouping model:"),
                "- ".concat(unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')),
                "- ".concat(parents.join(' > '))
            ].join('\n'));
        }
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    var groupId = columnGroupNode.groupId, children = columnGroupNode.children;
    children.forEach(function(child) {
        recurrentUnwrapGroupingColumnModel(child, _to_consumable_array(parents).concat([
            groupId
        ]), unwrappedGroupingModelToComplete);
    });
};
/**
 * This is a function that provide for each column the array of its parents.
 * Parents are ordered from the root to the leaf.
 * @param columnGroupingModel The model such as provided in DataGrid props
 * @returns An object `{[field]: groupIds}` where `groupIds` is the parents of the column `field`
 */ export var unwrapGroupingColumnModel = function(columnGroupingModel) {
    if (!columnGroupingModel) {
        return {};
    }
    var unwrappedSubTree = {};
    columnGroupingModel.forEach(function(columnGroupNode) {
        recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
export var getColumnGroupsHeaderStructure = function(orderedColumns, unwrappedGroupingModel, pinnedFields) {
    var _loop = function(depth) {
        var depthStructure = orderedColumns.reduce(function(structure, newField) {
            var _getParents_depth;
            var groupId = (_getParents_depth = getParents(newField)[depth]) !== null && _getParents_depth !== void 0 ? _getParents_depth : null;
            if (structure.length === 0) {
                return [
                    {
                        columnFields: [
                            newField
                        ],
                        groupId: groupId
                    }
                ];
            }
            var lastGroup = structure[structure.length - 1];
            var prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            var prevGroupId = lastGroup.groupId;
            if (prevGroupId !== groupId || !haveSameParents(prevField, newField, depth) || // Fix for https://github.com/mui/mui-x/issues/7041
            haveDifferentContainers(prevField, newField)) {
                // It's a new group
                return _to_consumable_array(structure).concat([
                    {
                        columnFields: [
                            newField
                        ],
                        groupId: groupId
                    }
                ]);
            }
            // It extends the previous group
            return _to_consumable_array(structure.slice(0, structure.length - 1)).concat([
                {
                    columnFields: _to_consumable_array(lastGroup.columnFields).concat([
                        newField
                    ]),
                    groupId: groupId
                }
            ]);
        }, []);
        groupingHeaderStructure.push(depthStructure);
    };
    var _Math;
    var getParents = function(field) {
        var _unwrappedGroupingModel_field;
        return (_unwrappedGroupingModel_field = unwrappedGroupingModel[field]) !== null && _unwrappedGroupingModel_field !== void 0 ? _unwrappedGroupingModel_field : [];
    };
    var groupingHeaderStructure = [];
    var maxDepth = (_Math = Math).max.apply(_Math, _to_consumable_array(orderedColumns.map(function(field) {
        return getParents(field).length;
    })));
    var haveSameParents = function(field1, field2, depth) {
        return isDeepEqual(getParents(field1).slice(0, depth + 1), getParents(field2).slice(0, depth + 1));
    };
    var haveDifferentContainers = function(field1, field2) {
        if ((pinnedFields === null || pinnedFields === void 0 ? void 0 : pinnedFields.left) && pinnedFields.left.includes(field1) && !pinnedFields.left.includes(field2)) {
            return true;
        }
        if ((pinnedFields === null || pinnedFields === void 0 ? void 0 : pinnedFields.right) && !pinnedFields.right.includes(field1) && pinnedFields.right.includes(field2)) {
            return true;
        }
        return false;
    };
    for(var depth = 0; depth < maxDepth; depth += 1)_loop(depth);
    return groupingHeaderStructure;
};
